import { createApp } from 'vue';
import { createPinia } from 'pinia';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import App from './App.vue';
import router from './router';
import directive from './utils/directive';
import VueI18n from '@/locales/i18n';
// import swiper from '@/components/swiper/index';
import { QuillEditor, Quill } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import quillEmoji from 'quill-emoji'
import 'quill-emoji/dist/quill-emoji.css'
import { VueMasonryPlugin } from "vue-masonry";
// 初始化一些东西
import '@/utils/initRem';
import '@css/index.scss';
import 'virtual:uno.css';
import 'highlight.js/styles/github.min.css';
// import 'github-markdown-css/github-markdown.css';


Quill.register('modules/quillEmoji', quillEmoji)
const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(directive);
app.use(VueI18n);
app.use(VueMasonryPlugin)
// 多语言翻译标记
app.config.globalProperties.$p = (param): string => param;

// 注册elementplus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
// app.component('swiper', swiper);
app.component('QuillEditor', QuillEditor)
app.mount('#app');
